<template>
  <div class="m-grid__item m-grid__item--fluid m-wrapper">
    <bread-crumb>
      <span slot="title">Single Business Permit</span>
      <ul class="m-subheader__BreadCrumbs m-nav m-nav--inline" slot="links">
        <li class="m-nav__item">
          <router-link :to="{ name: 'services', params: params }" class="m-nav__link">
            <span class="m-nav__link-text">
              Services
            </span>
          </router-link>
        </li>
        <li class="m-nav__separator">
          -
        </li>
        <li class="m-nav__item">
          <router-link :to="{ name: 'sbp', params: params }" class="m-nav__link">
            <span class="m-nav__link-text">
              SBP
            </span>
          </router-link>
        </li>
      </ul>
      <router-link :to="{name: 'addBusiness',params: params}" class="btn btn-success" slot="actions">
        <i class="fa fa-briefcase"></i> Add Business
      </router-link>
    </bread-crumb>
    <dash-content>
      <div class="row" slot="content">
        <div v-for="business in businesses" :key="business.id" class="col-md-4">
          <router-link :key="business.id" v-if="business.status === '1'" :to="{ name: 'business', params: { params, businessId: business.businessId }}">
            <div class="m-portlet">
              <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                  <div class="m-portlet__head-title">
                    <span class="m-portlet__head-icon">
                      <i class="flaticon-suitcase"></i>
                    </span>
                    <h3 class="m-portlet__head-text m--font-danger">
                      {{ business.businessName }}
                    </h3>
                  </div>
                </div>
                <div class="m-portlet__head-tools">
                  <span class="badge pull-right" :class="statusClass[business.status]">
                    {{ status[business.status] }}
                  </span>
                </div>
              </div>
              <div class="m-portlet__body">
                Business Number: {{ business.businessNo}}
              </div>
            </div>
          </router-link>
          <div v-else class="m-portlet">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <span class="m-portlet__head-icon">
                    <i class="flaticon-suitcase"></i>
                  </span>
                  <h3 class="m-portlet__head-text m--font-danger">
                    {{ business.businessName }}
                  </h3>
                </div>
              </div>
              <div class="m-portlet__head-tools">
                <span class="badge pull-right" :class="statusClass[business.status]">
                  {{ status[business.status] }}
                </span>
              </div>
            </div>
            <div class="m-portlet__body">
              Business Number: {{ business.businessNo}}
            </div>
          </div>
        </div>
      </div>
    </dash-content>
  </div>
</template>
<script>
import BreadCrumb from "../../partials/BreadCrumb";
import helpers from "../../../helpers";
import api from "../../../api";
import Content from "../../partials/Content";

export default {
  name: "Businesses",
  data() {
    return {
      businesses: [],
      params: this.$route.params,
      token: this.$store.state.token || window.localStorage.getItem("token"),
      status: [
        "Pending Approval",
        "Active",
        "Pending Approval",
        "Deactivation Request",
        "Inactive",
        "Deleted"
      ],
      statusClass: [
        "badge-warning",
        "badge-success",
        "badge-warning",
        "badge-warning",
        "badge-danger",
        "badge-danger"
      ]
    };
  },
  components: {
    BreadCrumb,
    "dash-content": Content
  },
  created: function() {
    let data = {
      countyId: this.params.countyId,
      token: this.token
    };
    const txType = "get-businesses";
    helpers.loading(true);
    api
      .request(txType, data)
      .then(response => {
        if (response.data.status === "00") {
          helpers.loading(false);
          this.businesses = response.data.businesses;
        } else {
          helpers.info({ show: true, message: response.data.message });
          this.businesses = [];
        }
      })
      .catch(error => {
        helpers.error({
          show: true,
          message: "An error occured. Please try again later."
        });
      });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/services/sbp/Businesses.vue